<template>
  <b-container class="home-container text-left">
    <b-row class="mb-3">
      <b-col clos="12">
        <h1 class="pb-4" style="font-size: 50px;">
          Piaci ESG tréningek
        </h1>
        <h3>
          <strong>
            A Magyar Gazdaságfejlesztési Ügynökségnél regisztrált piaci ESG tréningek nyilvántartása
          </strong>
        </h3>
      </b-col>
    </b-row>
    <div class="wrapper" style="color: black; display: flex; flex-wrap: wrap; align-items: center;">
      <div class="p-align">
        <div class="p-style mt-2">
          A Magyar Gazdaságfejlesztési Ügynökség elkötelezett az ESG szempontrendszer alapelvei mellett. Célunk, hogy
          támogassuk a hazai vállalkozásokat az elvárások teljesítésében, illetve az ahhoz szükséges módszertanok
          bevezetésében és alkalmazásában. Hisszük, hogy a fenntarthatóság, a társadalmi felelősségvállalás és az
          átlátható irányítás kulcsfontosságú a versenyképesség és hosszú távon is fenntartható működés biztosítása
          érdekében.
        </div>
        <div class="p-style mt-4">
          Fontosnak tartjuk, hogy lehetőséget biztosítsunk az ESG törvényben (2023. CVIII. tv.) megjelölt akkreditált
          ESG tanácsadó képzések mellett piaci alapú, rövidebb időintervallumú ESG tréningeket szervező
          képzőintézményeknek és tanácsadó cégeknek arra, hogy bemutatkozhassanak az oldalainkon, ezáltal segítve azon
          vállalatokat, akik számára nem feltétlenül szükséges az ESG akkreditált képzés teljesítése, azonban
          szeretnének tájékozódni az ESG-keretekről és elvárásokról, illetve mindennapi működésük során hasznosítható
          gyakorlati példákat szeretnének megismerni az egyes tréningeken.
        </div>
        <div class="p-style mt-4">
          Képzési listánkban tájékozódhat a 2026-ban futó, aktív jelentkezési lehetőséggel rendelkező tréningekről.
        </div>
        <div class="p-style-3 mt-4">
          A feltüntetett képzések tartalmáért és minőségéért a képzést meghirdető szervezetek felelősek. Az oldal
          üzemeltetője ezekért felelősséget nem vállal.
        </div>
      </div>
      <div>
        <img class="logoESGPiacitrening-style" src="../assets/img/logoESGPiacitrening.png" />
      </div>
    </div>
    <div class="wrapper-small">
      <div class="p-style-2 mb-1">
        <span>
          Amennyiben ESG tréning szervezőként szívesen megjelenítené képzését felületünkön, kérjük, hogy regisztráljon
          az alábbi gombra kattintva.
        </span>
        <span class="button-wrapper">
          <a class="button-href" href="https://forms.office.com/e/XbQ3L8PUYk?origin=lprLink" target="_blank">
            Kérelem benyújtása új képzés rögzítésére
          </a>
        </span>
      </div>
    </div>
    <!-- <b-col cols="12" class="mt-4 mb-5">
      <p style="font-style: italic; padding-left: 35px;">
        Az Önök által szolgáltatott információkat felülvizsgálat után megjelenítjük a VALI.HU/ESG oldalon.<br />
        Felhívjuk a figyelmüket, hogy olyan képzéseket áll módunkban közzétenni, amelyek futó képzések (2025-ben),
        nyilvános honlappal, valamint aktív jelentkezési lehetőséggel rendelkeznek, illetve az ESG téma vállalkozások
        szemszögéből történő feldolgozását tartják szem előtt.
      </p>
    </b-col> -->
    <b-col class="mt-5" style="text-align: center;">
      <h1>
        Tréningek listája
      </h1>
    </b-col>
    <b-row class="mt-5 mb-3">
      <b-col class="text-center desktop-only">
        <strong>
          <!-- görgethetőséget meg kell csinálni-->
          <b-row class="expert-wrapper">
            <b-col cols="12" lg="3" class="expert-title BoxTitle">
              Képzést nyújtó cég neve
            </b-col>
            <b-col cols="12" lg="4" class="expert-title BoxTitle">
              Képzés megnevezése
            </b-col>
            <b-col cols="12" lg="2" class="expert-title BoxTitle">
              Képzés óraszáma
            </b-col>
            <b-col cols="12" lg="3" class="expert-title BoxTitle">
              Képzés helyszíne
            </b-col>
          </b-row>
        </strong>
      </b-col>
      <b-col class="mobile-only">
        <h4>Képzések listája</h4>
      </b-col>
    </b-row>
    <b-row class="border border-1 mb-4 rounded " v-for="(expert, index) in experts" :key="index">
      <b-col cols="12" class="mt-3">
        <b-row class="expert-wrapper boxFirst mb-3 mt-3 desktop-only text-center">
          <b-col cols="12" lg="3" class="expert-title">
            <strong class="name">{{ expert.name }}</strong>
          </b-col>
          <b-col cols="12" lg="4" class="expert-title">
            {{ expert.trainingname }}
          </b-col>
          <b-col cols="12" lg="2" class="expert-title">
            {{ expert.traininghours }}
          </b-col>
          <b-col cols="12" lg="3" class="expert-title">
            {{ expert.location }}
          </b-col>
        </b-row>
        <!--mobil -->
        <b-row class="mobile-only">
          <b-col cols="6" lg="3" class="expert-title-mobil BoxTitleMobil">
            Képző cég
          </b-col>
          <b-col cols="6" lg="3" class="expert-title-mobil">
            <strong class="name">{{ expert.name }}</strong>
          </b-col>
          <b-col cols="6" lg="3" class="expert-title-mobil BoxTitleMobil">
            Képzés megnevezése
          </b-col>
          <b-col cols="6" lg="3" class="expert-title-mobil">
            {{ expert.trainingname }}
          </b-col>
          <b-col cols="6" lg="2" class="expert-title-mobil BoxTitleMobil">
            Képzés időtartama:
          </b-col>
          <b-col cols="6" lg="4" class="expert-title-mobil">
            {{ expert.trainingperiod }}
          </b-col>
          <b-col cols="6" lg="2" class="expert-title-mobil BoxTitleMobil">
            Képzés helyszíne
          </b-col>
          <b-col cols="6" lg="4" class="expert-title-mobil">
            {{ expert.location }}
          </b-col>
        </b-row>
        <b-row class="boxSecond mt-3">
          <b-col cols="12">
            <b-card-header header-tag="headerv" class="p-0" role="tab">
              <button v-b-toggle="'accordion-' + index" size="sm" class="buttonScrolling">
                Képzés részletei
                <span class="when-opened">
                  <ChevronRightIcon :size="22" />
                </span>
                <span class="when-closed">
                  <ChevronDownIcon :size="22" />
                </span>
              </button>
            </b-card-header>
            <b-collapse v-bind:id="'accordion-' + index">
              <div class="offer-description mt-3">
                <b-row class="blockBox">
                  <b-col cols="12" lg="12" class="pl-5 pr-5" style="text-align: justify;">
                    {{ expert.targetgroup }}
                  </b-col>
                  <b-col cols="12" lg="7" class="margin-box">
                    <competition-small-details :competition="offer" />
                    <b-row>
                      <b-col cols="12" lg="12" class="pb-2">
                        <strong>
                          Képzés időtartama:
                        </strong>
                        {{ expert.trainingperiod }}
                      </b-col>
                      <b-col cols="12" lg="12" class="pb-2">
                        <strong>Képzés módja:</strong>
                        {{ expert.trainingmethod }}
                      </b-col>
                      <b-col cols="12" lg="12" style="text-align: justify;">
                        <strong>Képzés célja:</strong>
                        {{ expert.trainingpurpose }}
                      </b-col>
                    </b-row>
                    <b-row class="mt-4 pl-3">
                      <b-button class="button" @click="handleOpenLinkInNewTab(expert.urlTraning)">
                        Tovább a képzés honlapjára
                      </b-button>
                    </b-row>
                  </b-col>
                  <b-col cols="12" lg="2" class="mt-5 desktop-only">
                    <img :src="expert.logo" class="expert-image" alt="Logó" />
                  </b-col>
                </b-row>
              </div>
            </b-collapse>
          </b-col>
        </b-row>
        <!--mobil-->
      </b-col>
    </b-row>
    <ESGButton />
  </b-container>
</template>

<script>
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue'
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue'
import ESGButton from './ESGButton.vue'
export default {
  name: 'ESGTreningek',
  components: {
    ChevronDownIcon,
    ChevronRightIcon,
    ESGButton
  },
  data() {
    return {
      experts: [
        // {
        //   name: '',
        //   trainingname: '',
        //   targetgroup: '',
        //   location: '',
        //   trainingperiod: '',
        //   traininghours: '',
        //   trainingmethod: '',
        //   trainingpurpose:
        //     '',
        //   urlTraning: '',
        //   logo: require('../assets/img/logoESGKepzes.png')
        // },
        /* {
          name: 'BDO Magyarország ESG Tanácsadó Kft.',
          trainingname: 'BDO ESG szakmai tréning',
          targetgroup:
            'Ajánlott: ESG projekt felelősöknek, akik meglevő feladataik mellett foglalkoznak ESG kérdésekkel. Az ESG projektek beszerzéséért felelős területek képviselőinek. Minden olyan szakmai vezetőknek, aki szeretné megismerni a vonatkozó ESG elvárásokat, ezek milyen feladatokat, kötelezettségeket rónak a vállalatra.',
          location: 'Budapest',
          trainingperiod: '2 nap',
          traininghours: '16 óra',
          trainingmethod: 'helyszíni',
          trainingpurpose:
            'A képzés során a BDO tapasztalt ESG tanácsadóinak segítségével sajátíthatja el az ESG alapfogalmait és gyakorlati alkalmazását. A program során bemutatásra kerülnek a fenntarthatósággal kapcsolatos fontosabb jogszabályi követelmények és nemzetközi standardok (CSRD/ESRS, ESG törvény előírások), amelyek ismeretében képessé válik a résztvevő az ESG jellegű projektek, kihívások azonosítására és értékelésére saját vállalata kontextusában. A BDO ESG terület projekt tapasztalatait felhasználó, gyakorlatorientált képzés elvégzésével a résztvevők birtokában lesznek a szükséges tudásnak és kompetenciáknak, amely révén alkalmasak lesznek arra, hogy magabiztosan kezeljenek ESG projekteket, és támogassák szervezetük fenntartható fejlődését.',
          urlTraning: 'https://www.bdo.hu/hu-hu/szakmai-kepzesek/bdo-esg-szakmai-trening',
          logo: require('../assets/img/logoESGKepzes.png')
        }, */
        {
          name: 'Budapesti Corvinus Egyetem',
          trainingname: 'Fenntarthatósági kommunikációs stratégiák',
          targetgroup:
            'Programunk olyan szakembereknek szól, akik kiegészítő feladatként vagy épp fő munkakörként foglalkoznak fenntarthatósági stratégiai kérdésekkel. Képzésünket olyan cégvezetőknek is ajánljuk, akik fontosnak tartják a fenntarthatóság gyakorlati alkalmazását saját vállalkozásukban.',
          location: 'Budapest',
          trainingperiod: '7 nap',
          traininghours: '36 óra',
          trainingmethod: 'helyszíni',
          trainingpurpose:
            'Olyan szakembereket képzünk, akik képesek megtervezni és megvalósítani a szervezetekre vonatkozó fenntarthatósági célokat. Ezen célokat releváns szakmai tanácsokkal, kommunikációs eszközökkel segítik a cégen belül, valamint hozzájárulnak a szervezet reputációjának növeléséhez.',
          urlTraning:
            'https://www.uni-corvinus.hu/post/landing-page/executive-kepzesek-a-corvinuson/fenntarthatosagi-kommunikacios-strategiak-executive-kepzes/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Budapesti Corvinus Egyetem',
          trainingname: 'LCA, vízlábnyom- és ökolábnyom-számítás alapjai - gyakorlati képzés',
          targetgroup:
            'Fenntarthatóság, környezettudomány, mérnöki és ESG területen dolgozó szakemberek és hallgatók ajánljuk.',
          location: 'Budapest',
          trainingperiod: '2 nap',
          traininghours: '10 óra',
          trainingmethod: 'helyszíni',
          trainingpurpose:
            'A Sustainable Business Academyvel együttműködésben megvalósuló képzés célja, hogy a résztvevők átfogó képet kapjanak a termékek és szolgáltatások környezeti hatásainak számszerűsítéséről a nemzetközi sztenderdekre épülő módszertanok (LCA – Life Cycle Assessment, vízlábnyom-számítás, ökolábnyom-számítás) segítségével. A tréning a gyakorlatra épít: a résztvevők nemcsak megismerik a módszertani kereteket, hanem szoftveres környezetben (openLCA) is kipróbálják az egyszerű és összetettebb modellezést. Külön hangsúlyt kap a víz- és ökolábnyom mutatók szerepe, gyakorlati alkalmazása és a vállalati fenntarthatósági jelentésekben való megjelenése.',
          urlTraning:
            'https://www.uni-corvinus.hu/post/landing-page/executive-kepzesek-a-corvinuson/lca-vizlabnyom-es-okolabnyom-szamitas-alapjai/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Budapesti Corvinus Egyetem',
          trainingname: 'Társadalmi felelősségvállalási stratégia kidolgozása',
          targetgroup:
            'A társadalmi felelősségvállalási stratégiák iránt érdeklődők és CSRD jelentést és ESG beszámolót készítő szakemberek részére ajánljuk.',
          location: 'Budapest',
          trainingperiod: '1 nap',
          traininghours: '8 óra',
          trainingmethod: 'helyszíni',
          trainingpurpose:
            'A képzés célja, hogy résztvevők átfogó ismereteket szerezzenek a társadalmi felelősségvállalás alapjairól, stratégiai tervezéséről és gyakorlati megvalósításáról. A kurzus gyakorlatorientált megközelítéssel segíti a résztvevőket abban, hogy saját vállalatuk számára hatékony stratégiát alakítsanak ki.',
          urlTraning:
            'https://www.uni-corvinus.hu/post/landing-page/executive-kepzesek-a-corvinuson/tarsadalmi-felelossegvallalasi-strategia-kidolgozasa/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Budapest Institute of Banking (BKF Fenntartó Kft.)',
          trainingname: 'ESG a gyakorlatban: Éghajlatváltozás, fenntarthatóság és dekarbonizáció a pénzügyi szektorban',
          targetgroup:
            'A képzés elsősorban a pénzügyi szektorban dolgozó szakembereknek szól, akik szeretnének többet megtudni az éghajlatváltozásról, a fenntarthatóságról és a dekarbonizációról. A képzés hasznos lehet bankok, biztosítók, alapkezelők és más pénzügyi intézmények munkatársai számára.',
          location: 'Budapest',
          trainingperiod: '1 nap',
          traininghours: '8 óra',
          trainingmethod: 'hibrid',
          trainingpurpose:
            'A képzés célja, hogy a résztvevők megértsék az éghajlatváltozás hatásait, a fenntarthatóság fontosságát és a dekarbonizáció szükségességét a pénzügyi szektorban. A képzés gyakorlati példákon és esettanulmányokon keresztül mutatja be, hogy a pénzügyi intézmények hogyan kezelhetik az éghajlati kockázatokat és a szabályozási környezetet.',
          urlTraning: 'https://www.bib-edu.hu/kurzusok/4155?categoryId=o-10&date_text=2025.%2004.%2029.',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Budapest Institute of Banking (BKF Fenntartó Kft.)',
          trainingname: 'Képesített zöld pénzügyek szakértő',
          targetgroup:
            'A képzés egy átfogó, a legfontosabb banki, biztosítási és tőkepiaci hatásokat és lehetőségeket bemutató képzés, így ajánljuk mindenkinek aki banki, pénzügyi területen dolgozik, vagy érdeklik a fenntartható pénzügyekkel kapcsolatos tudnivalók.',
          location: 'Budapest',
          trainingperiod: '2 nap',
          traininghours: '16 óra',
          trainingmethod: 'hibrid',
          trainingpurpose:
            'A képzés célja a klímaváltozásból és egyéb környezeti problémákból eredő kockázatok, új pénzügyi szabályozási követelmények és üzleti lehetőségek elsajátítása.',
          urlTraning: 'https://www.bib-edu.hu/kurzusok/2302?categoryId=o-10&date_text=Hamarosan',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'CAPEX TCO Kft',
          trainingname: 'ESG kérdőívet kaptam – segítség!',
          targetgroup: 'Beszállítóknak , KKV-knak, olyan cégeknek ajánljuk, akik nagyvállalati ESG kérdőívet kaptak',
          location: 'Magyarország területén, megrendelő címén',
          trainingperiod: 'Fél nap',
          traininghours: '4 óra',
          trainingmethod: 'Helyszíni és hibrid forma is elérhető',
          trainingpurpose: 'Hogyan töltsd ki helyesen a vevői ESG kérdőíveket – pánik nélkül',
          urlTraning: 'https://esgtanacsok.hu/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'CAPEX TCO Kft',
          trainingname: 'ESG law in Hungary',
          targetgroup: 'Beszállítóknak, KKV-knak ajánlott képzés',
          location: 'Magyarország területén, megrendelő címén',
          trainingperiod: 'Fél nap',
          traininghours: '4 óra',
          trainingmethod: 'Helyszíni és hibrid lehetőség is',
          trainingpurpose:
            'ESG nemzetközi kontextusba helyezve, azaz "Mit kell tudnia egy magyar cégnek az ESG törvényről?"',
          urlTraning: 'https://esgtanacsok.hu/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'CAPEX TCO Kft',
          trainingname: 'Hogyan építsünk ESG kompetenciát a vállalatnál?',
          targetgroup: 'Beszállítóknak, KKV-k menedzsmentjének ajánljuk.',
          location: 'Magyarország területén, megrendelő címén',
          trainingperiod: 'Fél nap',
          traininghours: '4 óra',
          trainingmethod: 'Helyszíni és hibrid is',
          trainingpurpose: 'Az ESG riportolási körülmények és folyamatok kialakítása',
          urlTraning: 'https://esgtanacsok.hu/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'denxpert EHS&S software Kft.',
          trainingname: 'denxpert ESG & CSRD szakmai webinársorozat',
          targetgroup:
            'Ajánlott közép- és nagyvállalatok fenntarthatósági, ESG, EHS, beszerzési és pénzügyi szakembereinek, valamint döntéshozóinak.',
          location: 'Online, országosan elérhető.',
          trainingperiod: 'Folyamatos, rendszeresen meghirdetett alkalmakkal',
          traininghours: 'Alkalmanként kb. 1 óra',
          trainingmethod: 'Online (élő webinár, utána felvételről visszanézhető); magyar és angol nyelven.',
          trainingpurpose:
            'Rövid, gyakorlatias szakértői webinárok az aktuális ESG-szabályozási változásokról és azok vállalati teendőiről. 2026-os témák: a felülvizsgált ESRS és a felkészülés a következő jelentéstételi ciklusra; az EU ellátási lánc átláthatósági szabályai (CSDDD, EUDR, kényszermunka-rendelet) és a beszállítói adatok kezelése; vállalati vízkockázatok és vízmegtartási stratégia Magyarországon; az ISO 14001:2026 klímavonatkozásai. Vendégelőadóink között tanácsadó cégek (pl. Deloitte) és szakértő partnerek vannak.',
          urlTraning: 'https://www.denxpert.com/hu/resources/learn/webinars',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Edutus Egyetem',
          trainingname: 'ESG alapozó tréning – Tudás minden munkatárs számára',
          targetgroup: 'HR területen dolgozóknak és teljes munkavállalói körnek ajánljuk.',
          location: 'élő online képzés',
          trainingperiod: '2 képzési alkalom',
          traininghours: '4 óra',
          trainingmethod: 'online, valós idejű élő online képzés',
          trainingpurpose:
            'Az alapozó tréning célja, hogy a munkatársak megértsék, mi az ESG, hogyan kapcsolódik a mindennapi tevékenységükhöz, és milyen szerepük van a felelős működésben. A képzés eredményeként a szervezet egészében kialakul egy közös ESG-nyelv és egy erősebb, tudatos elköteleződés a fenntartható működés iránt.',
          urlTraning:
            'https://www.edutus.hu/oktatas/felnottkepzesi-programok/esg-alapozo-trening-tudas-minden-munkatars-szamara/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Edutus Egyetem',
          trainingname: 'ESG a KKV-nak – Mini-tréningsorozat, gyakorlat fókusz',
          targetgroup: 'KKV-vezetőknek, kulcsmunkatársaknak ajánlott.',
          location: 'élő online képzés',
          trainingperiod: '3 képzési alkalom',
          traininghours: '6 óra',
          trainingmethod: 'online, valós idejű élő online képzés',
          trainingpurpose:
            'A képzés célja, hogy a kis- és középvállalkozások strukturált, átlátható és üzletileg is értelmezhető módon tudják megkezdeni ESG-felkészülésüket. A program eredményeként a résztvevők képessé válnak ESG-képes beszállítói működés kialakítására, stabil és átlátható alapokra helyezve fenntarthatósági gyakorlatukat.',
          urlTraning:
            'https://www.edutus.hu/oktatas/felnottkepzesi-programok/esg-a-kkv-nak-mini-treningsorozat-gyakorlat-fokusz/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Edutus Egyetem',
          trainingname: 'Vezetői ESG workshop – Stratégia és felelősség a döntéshozók kezében',
          targetgroup: 'Felsővezetőknek, compliance-felelősöknek, igazgatóknak ajánlott.',
          location: 'Budapest',
          trainingperiod: '1 képzési alkalom',
          traininghours: '4 óra',
          trainingmethod: 'helyszíni, személyes részvételen alapuló kontaktórás képzés',
          trainingpurpose:
            'A workshop célja, hogy a vezetők ne csupán reagáljanak a fenntarthatósági elvárásokra, hanem kezdeményezői és stratégiai irányítói legyenek a változásnak. A képzés eredményeként a résztvevők stratégiai rálátást és alkalmazható döntési keretrendszert szereznek ESG témában, amely támogatja a hosszú távú, felelős és versenyképes vállalatirányítást.',
          urlTraning: 'https://www.edutus.hu/oktatas/felnottkepzesi-programok/esg-proba/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'ESG Partner Kft.',
          trainingname: 'ESG Tréning KKV-knak - Fókuszban a finanszírozói és beszállítói kérdéssorok',
          targetgroup: 'Kis- és középvállalatoknak ajánljuk',
          location: 'Online / az igénybe vevő vállalat telephelye / Budapest',
          trainingperiod: '1 nap',
          traininghours: '8 óra',
          trainingmethod: 'online / személyesen',
          trainingpurpose:
            'A képzés célja olyan alapismeretek és információk átadása a piaci szereplők, kiemelten a KKV szektor szereplői számára, amely során megismerkedhetnek az ESG alapelveivel, az EU-s és hazai szabályozások részleteivel és elvárásaival, valamint a rájuk vonatkozó jelen- és jövőbeli feladatokkal, különös tekintettel az SZTFH beszállítói-, és a finanszírozás során használt MNB ajánlás szerinti kérdéssorra.',
          urlTraning: 'https://esgpartner.hu/oktatas/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'EU-SUCCESS Oktatásszervező és Tanácsadó Kft.',
          trainingname: 'ESG alapok 1.',
          targetgroup:
            'Ajánljuk azoknak a vállalati szakembereknek, KKV cégvezetőknek, beszerzési vezetőknek, akik még csak most ismerkednek az ESG fogalmával, a kapcsolódó jogszabályi- és egyéb követelményekkel. ',
          location: 'Budapest vagy az igénybe vevő cég telephelye',
          trainingperiod: 'fél nap',
          traininghours: '4 óra',
          trainingmethod: 'online vagy helyszíni formában  az igénybe vevő cég telephelyén',
          trainingpurpose:
            'A képzés során áttekintjük az E – S – G pillérek jelentését, tartalmát és értelmezését a vállalatok működésében, valamint az alapvető Európai Uniós és hazai szabályozókat. A képzés célja az ESG keretrendszer megértése és az alapvető fogalmak és elvárások tisztázása.',
          urlTraning: 'https://esgmindenkinek.hu/k%C3%A9pz%C3%A9sek',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'EU-SUCCESS Oktatásszervező és Tanácsadó Kft.',
          trainingname: 'ESG alapok 2.',
          targetgroup:
            'Ajánljuk azoknak a vállalati szakembereknek, KKV cégvezetőknek, beszerzési vezetőknek, akik még csak most ismerkednek az ESG fogalmával, a kapcsolódó jogszabályi- és egyéb követelményekkel. ',
          location: 'Budapest vagy az igénybe vevő cég telephelye',
          trainingperiod: '1 nap',
          traininghours: '8 óra',
          trainingmethod: 'online vagy helyszíni formában  az igénybe vevő cég telephelyén',
          trainingpurpose:
            'Az ESG keretrendszer megértése és az alapvető fogalmak és elvárások tisztázása, valamint a követelmények vállalati működésbe való átültetésének bemutatása.',
          urlTraning: 'https://esgmindenkinek.hu/k%C3%A9pz%C3%A9sek',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'EU-SUCCESS Oktatásszervező és Tanácsadó Kft.',
          trainingname: 'Vállalati ESG szakember',
          targetgroup:
            'Ajánljuk azoknak a vállalati szakembereknek, folyamatgazdáknak, akik a szervezeten belül részt vesznek az ESG adatgyűjtésben és adatszolgáltatásban, a fenntarthatósági jelentés ill. ESG beszámoló összeállításában.',
          location: 'Budapest vagy az igénybe vevő cég telephelye',
          trainingperiod: '2 nap',
          traininghours: '16 óra',
          trainingmethod: 'Online vagy helyszíni az igénybe vevő cég telephelyén',
          trainingpurpose:
            'A képzésben résztvevők megismerik a jelentéskészítés folyamatát, a kritikus lépéseket, a fenntarthatóság mérésére szolgáló adatgyűjtési rendszereket, és megtanulják értelmezni és adaptálni a jogszabályok (CSRD, ESG tv.) és a szabványok (ESRS) előírásait. A képzés során – gyakorlati példákon keresztül - részletesen bemutatjuk a kettős lényegességi elemzés, a kockázatértékelési rendszer és a stakeholder analízis folyamatát és eszközeit is. Előzetesen javasolt az ESG alapok 1. képzés elvégzése, az ESG alapfogalmainak és keretrendszerének elsajátítása.',
          urlTraning: 'https://esgmindenkinek.hu/k%C3%A9pz%C3%A9sek',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'EU-SUCCESS Oktatásszervező és Tanácsadó Kft.',
          trainingname: 'ESG projektmenedzsment képzés',
          targetgroup:
            'Ajánljuk azoknak a vállalati szakembereknek, tanácsadóknak, akik komplex ESG és fenntarthatósági stratégiai projektek tervezésével és  megvalósításával foglalkoznak.',
          location: 'Budapest, Veszprém',
          trainingperiod: '1 nap',
          traininghours: '8 óra',
          trainingmethod: 'Online vagy helyszíni',
          trainingpurpose:
            'A fenntarthatósági jelentés készítése az egész vállalaton átívelő feladat, ami a különböző szakterületek és szervezeti egységek összehangolt együttműködését igényli. Egy olyan komplex projekt, amely sikeresen csakis a projektmenedzsment eszközeivel és annak módszereit alkalmazva valósítható meg. A tréning során a résztvevők megismerik a sikeres ESG projektek lépéseit, a sikerkritériumokat és a kockázatokat, valamint gyakorlati tippeket és eszközöket kapnak ahhoz, hogy vállalatuknál az ESG projektet sikerre vigyék.',
          urlTraning: 'https://esgmindenkinek.hu/k%C3%A9pz%C3%A9sek',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'EU-SUCCESS Oktatásszervező és Tanácsadó Kft.',
          trainingname: 'ISO szabványokkal az ESG megfelelésért',
          targetgroup:
            'Ajánljuk ezt a képzést elsősorban minőség- vagy integrált irányítási rendszer vezetőknek, ESG projektmenedzsereknek, vállalati compliance szakértőknek, auditoroknak.',
          location: 'Budapest vagy az igénybe vevő cég telephelye',
          trainingperiod: 'fél nap',
          traininghours: '4 óra',
          trainingmethod: 'Online vagy helyszíni az igénybe vevő cég telephelyén',
          trainingpurpose:
            'Sok fenntarthatósági jelentés és/vagy ESG beszámoló készítésére kötelezett nagyvállalat rendelkezik már különböző ISO tanúsításokkal. Az ESG követelmények teljesítéséhez és jelentéstételhez a különböző nemzetközi (ISO) szabványok szerinti tanúsítások megfelelő alapot szolgáltatnak, hiszen ezen szabványok és a CSRD követelményei között sok a közös elem. A képzés során a résztvevők megismerik, hogy a szabványos követelményrendszerek (ISO9001, ISO14001, ISO45001, ISO50001, ISO27001, ISO37001) hogyan tudják támogatni az ESG megfelelést és az ESRS szabvány szerinti jelentéstételre való felkészülést. Gyakorlati példákkal és tippekkel segítjük a szinergiák megértését és kihasználását, annak érdekében, hogy a jelentéskészítés folyamatát leegyszerűsítsük.',
          urlTraning: 'https://esgmindenkinek.hu/k%C3%A9pz%C3%A9sek',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Greenpact Kft.',
          trainingname: 'Fenntarthatósági jelentéskészítés és ESG beszámoló gyakorlati workshop',
          targetgroup: 'Közép és nagyvállalatok munkatársainak ajánljuk',
          location: 'Budapest',
          trainingperiod: '1 nap',
          traininghours: '7 óra',
          trainingmethod: 'helyszíni',
          trainingpurpose:
            'A képzés célja, hogy megtanítsuk a résztvevőknek, hogyan készíthetnek fenntarthatósági és ESG jelentést a vállalkozásuk számára. A workshop során megismertetjük velük a legfontosabb lépéseket, módszertanokat és jogszabályi hátteret, valamint gyakorlati útmutatót biztosítunk a jelentéstétel folyamatához. Segítünk az előzetes adatgyűjtésben, a szektoranalízisben, az érintettek és lényeges témák meghatározásában, a kettős lényegességi elemzésben, az ESRS mutatók kiválasztásában, az adatgyűjtésben és számításokban, a stratégiaalkotásban, valamint az intézkedések megtérülésének és bevezetésének megértésében.',
          urlTraning: 'https://www.greenpact.hu/esg-workshop-marcius',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Greenpact Kft.',
          trainingname: 'VSME workshop – a gyakorlatban',
          targetgroup:
            'Azoknak a KKV és vállalati szakembereknek ajánljuk, akiknek nagyvállalati vevőjük, finanszírozó bankjuk vagy más üzleti partnerük VSME-alapú fenntarthatósági adatokat kér, vagy önkéntesen szeretnének fenntarthatósági jelentést készíteni.',
          location: 'Budapest',
          trainingperiod: '1 nap',
          traininghours: '6 óra',
          trainingmethod: 'helyszíni',
          trainingpurpose:
            'A képzés célja, hogy a résztvevők gyakorlati, mélyreható VSME-ismereteket szerezzenek, és átlássák a jelentéskészítés teljes folyamatát az adatgyűjtéstől a jelentés összeállításáig.',
          urlTraning: 'https://www.greenpact.hu/vsme-workshop',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Greenpact Kft.',
          trainingname: 'ESG rendszerépítő workshop',
          targetgroup: 'Ajánlott célcsoport: Vállalatvezetők, ESG-felelősök, beszállítói láncért felelősök',
          location: 'Budapest',
          trainingperiod: '1 nap',
          traininghours: '6 óra',
          trainingmethod: 'helyszíni',
          trainingpurpose:
            'A képzés célja, hogy a résztvevők saját szervezetükre szabva felépítsék az ESG-rendszer három alapját: a kockázatkezelést, a beszállítók értékelését és az átállási tervet. A workshop gyakorlati alapot ad egy auditálható, hosszú távon működő rendszer kialakításához.',
          urlTraning: 'https://www.greenpact.hu/beszallitoi-workshop',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Greenpact Kft.',
          trainingname: 'EcoVadis workshop',
          targetgroup:
            'Ajánlott ESG- és fenntarthatósági felelősöknek, beszerzési és beszállítói láncért felelősöknek, EcoVadis-felkérést kapott vagy beszállítóként minősülni kívánó vállalatoknak',
          location: 'Budapest',
          trainingperiod: '1 nap',
          traininghours: '6 óra',
          trainingmethod: 'helyszíni',
          trainingpurpose:
            'A képzés célja, hogy a résztvevők megismerjék az EcoVadis értékelési rendszerét, pontozási logikáját és dokumentációs elvárásait. Gyakorlati útmutatást kapnak a felkészüléshez, a fejlesztési prioritások kijelöléséhez és a következő értékelés megtervezéséhez.',
          urlTraning: 'https://www.greenpact.hu/ecovadis-workshop',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        /* {
          name: 'Greenpact Kft.',
          trainingname: 'Fenntarthatósági jelentéskészítés és ESG beszámoló metódusok gyakorlati workshop',
          targetgroup: 'Közép és nagyvállalatok munkatársainak ajánljuk',
          location: 'Budapest',
          trainingperiod: '3 nap',
          traininghours: '19 óra',
          trainingmethod: 'helyszíni',
          trainingpurpose:
            'A workshop célja, hogy a résztvevők elsajátítsák a fenntarthatósági jelentések és ESG beszámolók készítésének módszereit. A képzés során olyan témákat érintünk, mint a kettős lényegességi elemzés, az ESRS mutatók alkalmazása, a magyarországi ESG kérdőívek használata és a kockázatkezelési rendszerek kialakítása. ',
          urlTraning: 'https://www.greenpact.hu/esg-workshop-aprilis-23-25',
          logo: require('../assets/img/logoESGKepzes.png')
        }, */
        /* {
          name: 'HUN-REN Sztaki',
          trainingname: 'Fenntarthatósági mini képzés termelő vállalatok számára',
          targetgroup:
            'A képzést minden olyan szakembernek ajánljuk, aki szeretné megérteni az ESG és fenntarthatósági követelmények hatását a termelő vállalatok működésére. A képzés során rövid, fókuszált formában járjuk körbe a fenntarthatóság és az ESG legfontosabb fogalmait és irányait, így ideális azoknak, akik most ismerkednek a témával. Ugyanakkor gyakorlati, üzleti fókuszú eszközöket is bemutatunk, amelyek a tapasztaltabb szakemberek számára is tartogathatnak újdonságokat.',
          location: 'Online',
          trainingperiod: '4 x 1 óra',
          traininghours: '4 x 1 óra',
          trainingmethod: 'online',
          trainingpurpose:
            'A fenntarthatóság, a körforgásosság és az ESG elvárások ma már elkerülhetetlenek a termelő vállalatok számára, miközben a folyamatosan változó jogszabályi környezet új kihívásokat teremt. A HUN-REN SZTAKI négyrészes, gyakorlatközpontú online képzése segít eligazodni ebben a komplex témakörben, kifejezetten a termelő vállalatok igényeire szabva. A 4*1 órás képzés során áttekintjük a legfrissebb hazai és nemzetközi szabályozási elvárásokat, összefoglaljuk az alapelveket, bemutatjuk a legfontosabb témaköröket. Mivel a fenntarthatóság és digitalizáció, az ESG, az Ipar 4.0 és a mesterséges intelligencia egyre inkább összefonódnak, a képzés során bemutatunk olyan innovációkat, melyek a fenntartható működést támogatják.',
          urlTraning:
            'https://sztaki.hun-ren.hu/aktualitasok/hirek/2025/termelo-vallalatok-szamara-tart-ingyenes-fenntarthatosagi-kepzest-hun-ren',
          logo: require('../assets/img/logoESGKepzes.png')
        }, */
        {
          name: 'Ingenium Alliance Kft.',
          trainingname: 'Vállalati ESG ismeretek',
          targetgroup: 'Ajánlott: Vállalati ESG felelősöknek, nagyvállalatoknak, kis- és középvállalkozásoknak',
          location: 'Budapest',
          trainingperiod: '2 nap',
          traininghours: '16 óra',
          trainingmethod: 'online',
          trainingpurpose:
            'A „Vállalati ESG ismeretek” képzés átfogó megértést biztosít a fenntarthatóságról, az ESG keretrendszerekről, jogszabályokról, valamint a klímaváltozás vállalati szintű kezeléséről. A képzés egyedülálló módon ötvözi az elméleti tudást a gyakorlati alkalmazással.',
          urlTraning: 'https://www.esgkepzes.hu/kepzesek',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'IWS Solutions Kft.',
          trainingname: 'A vállalati fenntarthatóság és az ESG célok megvalósításának gyakorlati lépései',
          targetgroup:
            'Ez a képzés azoknak a cégeknek és szakembereknek szól, akik már tisztában vannak az ESG alapokkal és a jogszabályi elvárásokkal (például a CSRD és a magyar ESG törvény módosításokkal), de most a hogyanra keresik a választ. Kifejezetten ajánljuk:  Projektvezetők és menedzserek: Akik felelősek az ESG stratégiák és projektek implementálásáért, koordinálásáért a különböző részlegek között.  Munkacsoportok tagjai: Akik az ESG jelentések elkészítésében, az adatok gyűjtésében és a belső folyamatok átalakításában vesznek részt.  Innovációs és fejlesztési vezetők: Akik új, fenntartható termékeket, szolgáltatásokat vagy üzleti modelleket akarnak bevezetni.  Operatív vezetők: Gyártási, logisztikai, vagy beszerzési vezetők, akik a mindennapi működésben szeretnék csökkenteni a környezeti terhelést és javítani a társadalmi hatást.  Belső ESG felelősök: Akik a vállalat ESG programjának irányítását és végrehajtását felügyelik.  Azon HR, beszerzési, pénzügyi és kommunikációs szakemberek, akik már ismerik az alapokat, és most a konkrét gyakorlati lépésekre, implementációs megoldásokra kíváncsiak.',
          location: 'Online',
          trainingperiod: '3 nap',
          traininghours: '18 óra',
          trainingmethod: 'online',
          trainingpurpose:
            'Képzésünk a fenntarthatósági és ESG célok elméleti alapjaira építve,  a konkrét, gyakorlati megvalósításra fókuszál. Célja, hogy a vállalatok ne csak beszéljenek a fenntarthatóságról, hanem valóban cselekedjenek, és beépítsék azt mindennapi működésükbe.',
          urlTraning:
            'https://kepzes.iws.hu/kepzes/a-vallalati-fenntarthatosag-es-az-esg-celok-megvalositasanak-lepesei/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'IWS Solutions Kft.',
          trainingname: 'A vállalati fenntarthatóság kialakításának és az ESG kötelezettségek teljesítésének alapjai',
          targetgroup:
            'KKV-k döntéshozói és döntéselőkészítő munkatársainak; nemzetközi vállalati és nagyvállalati kontrolling és pénzügyi szakemberei részére, HR, EHS, CSR, energetikai továbbá; minőségbiztosítási- és vezető tanácsadói szakembereinek ajánlott',
          location: 'Online',
          trainingperiod: '3 nap',
          traininghours: '18 óra',
          trainingmethod: 'online',
          trainingpurpose:
            'Tréningünk elvégzésével,résztvevőink átfogó ismereteket szerezhetnek a globális felmelegedés az üzleti szférát érintő hatásairól és a vállalati fenntarthatóság kialakításával kapcsolatos tevékenységek, illetve elvárások rendszeréről. Betekintést nyerhetnek a fenntarthatóság kialakításával járó üzleti kockázatok rendszerébe, az ESG megfeleléssel kapcsolatos vállalati értékláncokat érintő kötelezettségekbe. Képesek lesznek a vállalati ESG-k szerinti mitigációs és adaptációs tevékenység értelmezésére, és gyakorlati készségek kialakításával az ezekhez kapcsolódó indikátorkészletek mentén konkrét beavatkozások elindítására. A kurzuson jelenlévők, információt kapnak a 2024-ben életbe lépett EU szabályzókról, a vevői és a német beszállítói átvilágítási kötelezettségek teljesítésével kapcsolatos feladatokról, kiemelve a környezetvédelmi, emberjogi, munkaegészségügyi és egyéb ESG-ket érintő területeket.',
          urlTraning:
            'https://kepzes.iws.hu/kepzes/vallalati-esg-kotelezettsegek-es-fenntarthatosagi-kockazatmenedzsment/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'IWS Solutions Kft.',
          trainingname: 'Vállalati ESG célok megvalósításának HR vetületei',
          targetgroup:
            'Célcoportok, akiknek ajánlott: HR vezetőknek és igazgatóknak: Akiknek átfogó képet kell kapniuk arról, hogyan integrálhatják az ESG szempontokat a HR stratégiába és a mindennapi működésbe.  HR business partnereknek (HRBP-k): Akik közvetlenül támogatják az üzleti egységeket, és az ESG elveket be kell építeniük a részlegspecifikus HR gyakorlatokba.  Toborzási és kiválasztási szakembereknek: Akik a fenntarthatósági szempontokat figyelembe veszik a tehetségek vonzásában és kiválasztásában.  Képzési és fejlesztési szakembereknek: Akik felelősek az ESG-vel kapcsolatos tudás és képességek fejlesztéséért a munkavállalók körében.  Juttatási és kompenzációs szakemberek: Akik a méltányos bérezés, a munka-magánélet egyensúlya és a munkavállalói jólét ESG-szempontú megközelítésével foglalkoznak.  Belső kommunikációs szakemberek: Akik az ESG célokat és eredményeket a munkavállalók felé kommunikálják.  Compliance és jogi szakemberek, akik az ESG „S” pillérével kapcsolatos jogszabályi megfelelésért felelnek (pl. munkajog, diszkriminációellenesség).',
          location: 'Online',
          trainingperiod: '2 nap',
          traininghours: '12 óra',
          trainingmethod: 'Online',
          trainingpurpose:
            'Tréningünk elvégzésével, résztvevőink konkrét ismereteket szerezhetnek a vállalati fenntarthatósággal kapcsolatos „S”, „G” indikátorkészlet, és a HR érintettségű ESG célok elérését támogató projektek megvalósításával kapcsolatos lépésekről. Betekintést nyerhetnek a fenntarthatóság kialakításával járó „S”, „G” indikátorokhoz kapcsolódó üzleti kockázatokba, az ESG megfeleléssel kapcsolatos HR, EHS munkatársakra háruló felelősség rendszerébe. Gyakorlati készségek kialakításával képesek lesznek a HR & EHS területeket érintő vállalati mitigációs és adaptációs lépések elindítására, továbbá CSDD/LKSG beszállítói átvilágítás elvárásai szerint kötelezettségek lebonyolítására. További részleteket a képzés honlapján olvashat.',
          urlTraning: 'https://kepzes.iws.hu/kepzes/vallalati-esg-celok-megvalositasanak-hr-vetuletei/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'IWS Solutions Kft.',
          trainingname: 'Vállalati ESG célok megvalósításának szállítói aspektusai',
          targetgroup:
            'Beszerzési vezetőknek, fenntarthatósági szakembereknek, ellátási lánc menedzsereknek és vállalatvezetőknek ajánljuk.',
          location: 'Online',
          trainingperiod: '2 alkalom',
          traininghours: '12 óra',
          trainingmethod: 'Online',
          trainingpurpose:
            'A tanfolyam célja: hogy a résztvevők megismerjék az ESG szempontok integrálásának fontosságát a szállítói kapcsolatokban, valamint elsajátítsák a szükséges eszközöket és módszereket a fenntartható ellátási lánc kialakításához. Tréningünk elvégzésével, résztvevőink konkrét ismereteket szerezhetnek a szállítói láncok fenntarthatósági- és ESG kötelezettségeivel kapcsolatos „E”, „S”, „G” indikátorkészletre vonatkozó átvilágítási kötelezettségekkel kapcsolatos projectek lépéseiről. Betekintést nyerhetnek az üzleti kockázatok kezelésére vonatkozó adatkészletbe, amelyeket az ESG megfeleléssel kapcsolatos vevői auditok során várnak el. Gyakorlati készségek kialakításával képesek lesznek a CSDD/LKSG beszállítói átvilágítás elvárásai szerint kötelezettségek lebonyolítására.',
          urlTraning: 'https://kepzes.iws.hu/kepzes/vallalati-esg-celok-megvalositasanak-szallitoi-aspektusai/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Luko-Green Tanácsadó Kft.',
          trainingname: 'A fenntarthatóság GYAKORLATI útja',
          targetgroup: 'Célcsoport: vállalkozások vezetői, tulajdonosai, középvezetők',
          location: 'Dél-Alföldi Régió, Kecskemét',
          trainingperiod: '1 nap',
          traininghours: '3 óra',
          trainingmethod: 'hibrid',
          trainingpurpose: 'Szemléletformáló képzés - a fenntarthatóság és az ESG gyakorlati megközelítése',
          urlTraning: 'https://luko-green.hu/kepzesek',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        /* {
          name: 'Luko-Green Tanácsadó Kft.',
          trainingname: 'ESG kérdőív - mihez kezdjek vele?',
          targetgroup: 'Célcsoport: vállalkozások vezetői, tulajdonosai, középvezetők',
          location: 'Dél-Alföldi Régió, Kecskemét',
          trainingperiod: '1 nap',
          traininghours: '4 óra',
          trainingmethod: 'hibrid',
          trainingpurpose: 'Gyakorlati képzés beszállítóknak az ESG kérdőív értelmezéséhez és kitöltéséhez',
          urlTraning: 'https://luko-green.hu/kepzesek',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Luko-Green Tanácsadó Kft.',
          trainingname: 'Az "E" betű -  hogyan induljunk el a fenntartható KÖRNYEZET felé?',
          targetgroup: 'Célcsoport: vállalkozások vezetői, tulajdonosai, középvezetők',
          location: 'Dél-Alföldi Régió, Kecskemét',
          trainingperiod: '1 nap',
          traininghours: '4 óra',
          trainingmethod: 'hibrid',
          trainingpurpose: 'Az ESG környezeti szempontjainak megismerése, gyakorlati útmutatás az elinduláshoz',
          urlTraning: 'https://luko-green.hu/kepzesek',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Luko-Green Tanácsadó Kft.',
          trainingname: 'Az "S" betű - mi mindent jelent vállalkozásunknak a TÁRSADALMI fenntarthatóság?',
          targetgroup: 'Célcsoport: vállalkozások vezetői, tulajdonosai, középvezetők',
          location: 'Dél-Alföldi Régió, Kecskemét',
          trainingperiod: '1 nap',
          traininghours: '4 óra',
          trainingmethod: 'hibrid',
          trainingpurpose: 'Az ESG társadalmi vetületének megismerése, gyakorlati útmutatás az elinduláshoz',
          urlTraning: 'https://luko-green.hu/kepzesek',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Luko-Green Tanácsadó Kft.',
          trainingname: 'A "G" betű - a fenntartható vállalkozás magja a FELELŐS VÁLLALATIRÁNYÍTÁS, de mi is ez?',
          targetgroup: 'Célcsoport: vállalkozások vezetői, tulajdonosai, középvezetők',
          location: 'Dél-Alföldi Régió, Kecskemét',
          trainingperiod: '1 nap',
          traininghours: '4 óra',
          trainingmethod: 'hibrid',
          trainingpurpose:
            'Az ESG - felelős vállalatirányítás jelentése, gyakorlati szempontok a fenntartható vállalati stratégia megalkotásához és végrehajtásához',
          urlTraning: 'https://luko-green.hu/kepzesek',
          logo: require('../assets/img/logoESGKepzes.png')
        }, */
        {
          name: 'Malibo Kft.',
          trainingname: 'Vállalati ESG szakember',
          targetgroup:
            'Ajánlott: Cégvezetőknek, minőségügyi, pénzügyi, gazdasági, operatív, HR, logisztikai és beszerzési, értékesítési, marketing és PR vezetőnek és munkatársaknak, szakembereknek, akik a vállalat fenntarthatósági kérdéseivel foglalkoznak akár a kialakítás, meglévő rendszerekbe integrálás, működtetés vagy fejlesztés területén',
          location: 'Budapest',
          trainingperiod: '3 nap',
          traininghours: '24 óra',
          trainingmethod: 'hibrid',
          trainingpurpose:
            'A képzés célja a fenntartható vállalati működés és az ESG-szemlélet vállalati szintű alkalmazásának bemutatása, különös tekintettel a bevezetés, a működtetés és a jelentéstétel folyamataira. A program átfogó ismereteket nyújt a korszerű digitális ESG rendszerek használatáról, támogatva a szervezeteket abban, hogy a saját igényeikhez és erőforrásaikhoz illeszkedő megoldásokat vezessenek be. A résztvevők a képzés végére megértik a fenntarthatósági elvek vállalatirányításba történő integrálásának követelményeit, képesek azonosítani a kapcsolódó feladatokat, és aktívan részt tudnak venni az ESG jelentések előkészítésében.',
          urlTraning: 'https://esginfo.hu/oktatas/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Nemzetközi Bankárképző Központ Zrt.',
          trainingname: 'ESG szempontok a vállalatok banki finanszírozásában',
          targetgroup:
            'Vállalati ügyfelekkel foglalkozók banki munkatársaknak, illetve a vállalatok ESG működtetésében érdekelt menedzsereknek ajánlott képzés.',
          location: 'online',
          trainingperiod: '6 hónapos hozzáférés',
          traininghours: '8 óra',
          trainingmethod: 'online',
          trainingpurpose:
            'Megismeri azokat a szempontokat, folyamatokat és előírásokat, amelyek befolyással vannak a vállalkozások ESG tevékenységére.',
          urlTraning: 'https://www.bankarkepzo.hu/oktatas/programok/esg-szempontok-vallalatok-banki-finanszirozasaban',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        /* {
          name: 'Nemzetközi Bankárképző Központ Zrt.',
          trainingname: 'EFPA ESG Befektetési Tanácsadó képzés',
          targetgroup: 'Célcsoport: pénzügyi tanácsadók, befektetési tanácsadók',
          location: 'Budapest',
          trainingperiod: '2 nap',
          traininghours: '16 óra',
          trainingmethod: 'hibrid',
          trainingpurpose:
            'Megismerni a Befektetésekkel kapcsolatos haza és nemzetközi ESG-előírásokat és gyakorlatot.',
          urlTraning: 'https://www.bankarkepzo.hu/oktatas/programok/efpa-esg-befektetesi-tanacsado-kepzes',
          logo: require('../assets/img/logoESGKepzes.png')
        }, */
        {
          name: 'Nemzetközi Bankárképző Központ Zrt.',
          trainingname: 'Certified ESG Analyst (CESGA)',
          targetgroup: 'Célcsoport: vállalatelemzők, befektetéselemzők, portfóliómenedzserek, vagyonkezelők ',
          location: 'online',
          trainingperiod: '6 hónapos hozzáférés',
          traininghours: '50 óra',
          trainingmethod: 'online e-learning',
          trainingpurpose: 'Építse be az ESG-szempontokat az elemzői munkába! Szerezzen nemzetközi végzettséget!',
          urlTraning: 'https://www.bankarkepzo.hu/oktatas/programok/certified-esg-analyst-cesga-r',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        /* {
          name: 'Pannon Egyetem - Körforgásos Gazdaság Egyetemi Központ',
          trainingname: 'Introduction to Circular Economy (angol nyelvű)',
          targetgroup: 'Vállalkozások, gazdasági társaságok számára ajánlott.',
          location: 'Nagykanizsa',
          trainingperiod: '5 nap',
          traininghours: '25 óra',
          trainingmethod: 'helyszíni',
          trainingpurpose:
            'A képzés célja, hogy vállalati és intézményi döntéshozók számára alapvető ismereteket nyújtson a körforgásos gazdaság modelljéről. A tanfolyam átfogó módon összefoglalja e  téma legfontosabb elméleti és gyakorlati kérdéseit.',
          urlTraning: 'https://pen.uni-pannon.hu/blog/introduction-to-circular-economy-for-business-organizations/',
          logo: require('../assets/img/logoESGKepzes.png')
        }, */
        /* {
          name: 'Pannon Egyetem - Körforgásos Gazdaság Egyetemi Központ',
          trainingname: 'Bevezetés a körforgásos gazdaságba',
          targetgroup:
            'Vállalati vezetők, szakemberek, az üzleti élet szereplői számára ajánlott, akik szeretnének megismerkedni a körforgásos gazdaság alapjaival.',
          location: 'Részben online, a jelenléti órák Nagykanizsán vagy a megrendelővel egyeztetett helyszínen',
          trainingperiod: '3 alkalom',
          traininghours: '3x5 óra',
          trainingmethod: 'hibrid',
          trainingpurpose:
            'A képzés célja a vállalati, intézményi döntéshozók számára a körforgásos gazdasági modellhez kapcsolódó tudás megalapozása. A kurzus komplex módon foglalja össze a napjainkban formálódó témakör legfontosabb elméleti és gyakorlati kérdéseit.',
          urlTraning: 'https://pen.uni-pannon.hu/blog/korforgasos-gazdasag/',
          logo: require('../assets/img/logoESGKepzes.png')
        }, */
        /* {
          name: 'Pannon Egyetem - Körforgásos Gazdaság Egyetemi Központ',
          trainingname: 'Bevezetés a körforgásos gazdaságba – a körforgásos gazdaság jelentősége a turizmusban',
          targetgroup:
            'Vállalati vezetők, szakemberek, az üzleti élet szereplői részére ajánlott, a turizmus és más kapcsolódó ágazatok területén, akik szeretnének megismerkedni a körforgásos gazdaság alapjaival.',
          location: 'Nagykanizsán vagy a megrendelővel egyeztetett helyszínen.',
          trainingperiod: '1 nap',
          traininghours: '8 óra',
          trainingmethod: 'személyes',
          trainingpurpose:
            'A képzés célja a vállalati, intézményi döntéshozók számára a körforgásos gazdasági modellhez kapcsolódó tudás megalapozása. A kurzus komplex módon foglalja össze a napjainkban formálódó témakör legfontosabb elméleti és gyakorlati kérdéseit, külön kitekintéssel a turizmus területére.',
          urlTraning:
            'https://pen.uni-pannon.hu/blog/korforgasos-gazdasagbra-korforgasos-gazdasag-jelentosege-a-turizmusban/',
          logo: require('../assets/img/logoESGKepzes.png')
        }, */
        {
          name: 'Pannon Egyetem ',
          trainingname: 'ESG specialista',
          targetgroup:
            'Olyan szakembereknek, az üzleti élet szereplőinek ajánljuk, akik szeretnének:  Megismerkedni az ESG alapfogalmaival, összefüggéseivel és szabályozói környezetével. Felismerni az egyes szakterületek közötti kapcsolatokat és szakmai értékelést végezni ezek alapján. Hitelesen és szakszerűen közvetíteni az ESG-vel kapcsolatos problémaköröket és megoldási javaslatokat. Felelősséget vállalni döntéseikért, különösen azok környezeti és társadalmi következményeiért.',
          location: 'Veszprém',
          trainingperiod: '3 hónap',
          traininghours: '100 óra',
          trainingmethod: 'online',
          trainingpurpose:
            'A képzés célja a vállalati, intézményi döntéshozók, menedzserek számára az ESG (környezeti, társadalmi, irányítási jelentéstétel) bevezetésével, menedzselésével kapcsolatos ismeretek megalapozása. A képzés komplex módon foglalja össze az ESG alapjait, fókuszterületeit, a jogszabályi és partneri megfelelés kritériumait.',
          urlTraning: 'https://www.gtk.uni-pannon.hu/hu/esg-specialista/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        /* {
          name: 'PwC Könyvvizsgáló Kft. (PwC’s Academy)',
          trainingname: 'ESG szakértő menedzser',
          targetgroup:
            'Ajánljuk azon felsővezetőknek, akik meg akarják érteni az ESG üzletre gyakorolt hatását ; Azon operatív vezetőknek, akik meg akarják ismerni a rendszer bevezetéséhez szükséges különféle szempontokat ; A vállalaton belüli ESG feladatokat ellátóknak, hogy képet kapjanak arról, hogyan kell teljesíteniük a rendelet különböző előírásait ;  A vállalati pénzügyekkel és gazdálkodással foglalkozó kollégáknak, hogy megértsék a jelentési folyamat vonatkozó részeit; A marketing és befektetői kommunikációs csapat tagjainak, az ESG adatok átlátható és értelmes bemutatása érdekében;  A HR-csapatok tagjainak, az ESG-jelentési folyamatban betöltött szerepüket megértése érdekében.',
          location: 'Budapest',
          trainingperiod: '5 alkalom',
          traininghours: '30 óra',
          trainingmethod: 'helyszíni',
          trainingpurpose:
            'A négy modulból álló képzés célja,  átfogó, strukturált és gyakorlatias alapot biztosítson az ESG értelmezéséhez és a kötelezettségek megértéséhez, kifejezetten vállalati működésre szabva.',
          urlTraning:
            'https://www.pwc.com/hu/hu/academy/esg/hiteles_vallalati_eszkozrendszer_a_fenntarthatosagi_atalakulashoz.html',
          logo: require('../assets/img/logoESGKepzes.png')
        }, */
        {
          name: 'PwC Könyvvizsgáló Kft. (PwC’s Academy)',
          trainingname: 'ESG szakértő képzés',
          targetgroup:
            'Ajánljuk mindazoknak, akik szeretnék megérteni, hogyan lehet vállalkozásuk sikeres az ESG-korszakban, és versenyelőnyt kovácsolnának a jogszabályi változásokból. Különösen hasznos felső- és operatív vezetők, ESG-feladatokat ellátó szakemberek, pénzügyi és gazdálkodási területen dolgozó kollégák, valamint a marketing, befektetői kommunikációs és HR-csapatok tagjai számára, akik szeretnék megérteni az ESG üzleti hatásait, bevezetésének szempontjait és a kapcsolódó jelentési, kommunikációs, illetve megfelelési követelményeket.',
          location: 'Budapest',
          trainingperiod: '4 alkalom',
          traininghours: '16 óra',
          trainingmethod: 'helyszíni',
          trainingpurpose:
            'A gyakorlatorientált tréning során a résztvevők átfogó módon megismerkednek az ESG fogalmával, a bevezetés előnyeivel és az érintettek szerepeivel. A tananyag kitér mindazokra a naprakész információkra, amelyek tartalmazzák a jogszabályi előírásokat és a várható változásokat is. A képzés elvégzését követően a résztvevők képessé válnak a vállalat főbb ESG értékeinek azonosítására és az ESG stratégia kialakításában való hatékony közreműködésre.',
          urlTraning:
            'https://www.pwc.com/hu/hu/academy/esg/hiteles_vallalati_eszkozrendszer_a_fenntarthatosagi_atalakulashoz.html',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'PwC Könyvvizsgáló Kft. (PwC’s Academy)',
          trainingname: 'ESG szakértő képzés - 1. modul: ESG és szabályozási környezet – alapok',
          targetgroup:
            'Ajánljuk azoknak, akik szeretnék megérteni, hogyan lehet sikeres a vállalkozásuk az új, ESG-korszakban. Akik a nyertesei szeretnének lenni a jogszabályi változásoknak, és a vállalkozásuk ellenálló képességének javítására akarják ezt felhasználni. Azon felsővezetőknek, akik meg akarják érteni az ESG üzletre gyakorolt hatását. Azon operatív vezetőknek, akik meg akarják ismerni a rendszer bevezetéséhez szükséges különféle szempontokat. A vállalaton belüli ESG feladatokat ellátóknak, hogy képet kapjanak arról, hogyan kell teljesíteniük az ESG-vel kapcsolatos jogszabályok különböző előírásait. A vállalati pénzügyekkel és gazdálkodással foglalkozó kollégáknak, hogy megértsék a jelentési folyamat vonatkozó részeit. A marketing és befektetői kommunikációs csapat tagjainak, az ESG adatok átlátható és értelmes bemutatása érdekében. A HR-csapatok tagjainak, az ESG-jelentési folyamatban betöltött szerepüket megértése érdekében.',
          location: 'Budapest',
          trainingperiod: 'fél nap',
          traininghours: '4 óra',
          trainingmethod: 'helyszíni',
          trainingpurpose:
            'A képzés célja, hogy a résztvevők átfogó képet kapjanak az ESG-szabályozási környezetről, a fenntarthatósági jelentéstétel követelményeiről és azok üzleti jelentőségéről. A képzés segítséget nyújt a legfontosabb ESG-szabványok, kötelezettségek és kapcsolódó uniós szabályozások megértésében, valamint felkészíti a résztvevőket arra, hogy szervezetükben hatékonyan támogassák a fenntarthatósági megfelelést és a stratégiai döntéshozatalt.',
          urlTraning:
            'https://www.pwc.com/hu/hu/academy/esg/hiteles_vallalati_eszkozrendszer_a_fenntarthatosagi_atalakulashoz.html',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'PwC Könyvvizsgáló Kft. (PwC’s Academy)',
          trainingname:
            'ESG szakértő képzés - 2. modul: Kiegészítő ESG témák - greenwashing, pay transparency, karbonlábnyom',
          targetgroup:
            'Ajánljuk azoknak, akik szeretnék megérteni, hogyan lehet sikeres a vállalkozásuk az új, ESG-korszakban. Akik a nyertesei szeretnének lenni a jogszabályi változásoknak, és a vállalkozásuk ellenálló képességének javítására akarják ezt felhasználni. Azon felsővezetőknek, akik meg akarják érteni az ESG üzletre gyakorolt hatását. Azon operatív vezetőknek, akik meg akarják ismerni a rendszer bevezetéséhez szükséges különféle szempontokat. A vállalaton belüli ESG feladatokat ellátóknak, hogy képet kapjanak arról, hogyan kell teljesíteniük az ESG-vel kapcsolatos jogszabályok különböző előírásait. A vállalati pénzügyekkel és gazdálkodással foglalkozó kollégáknak, hogy megértsék a jelentési folyamat vonatkozó részeit. A marketing és befektetői kommunikációs csapat tagjainak, az ESG adatok átlátható és értelmes bemutatása érdekében. A HR-csapatok tagjainak, az ESG-jelentési folyamatban betöltött szerepüket megértése érdekében.',
          location: 'Budapest',
          trainingperiod: 'fél nap',
          traininghours: '4 óra',
          trainingmethod: 'helyszíni',
          trainingpurpose:
            'A képzés célja, hogy a résztvevők megismerjék az ESG-jelentéstétel hitelességét, átláthatóságát és mérhetőségét támogató kulcstémákat. A program gyakorlati segítséget nyújt a greenwashing kockázatainak kezeléséhez, a bértranszparenciával kapcsolatos követelmények megértéséhez, valamint a vállalati karbonlábnyom mérésének, jelentésének és csökkentésének alapjaihoz, ezzel támogatva a fenntarthatósági célok hatékony megvalósítását.',
          urlTraning:
            'https://www.pwc.com/hu/hu/academy/esg/hiteles_vallalati_eszkozrendszer_a_fenntarthatosagi_atalakulashoz.html',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'PwC Könyvvizsgáló Kft. (PwC’s Academy)',
          trainingname: 'ESG szakértő képzés - 3. modul: A magyar ESG-törvény a gyakorlatban',
          targetgroup:
            'Ajánljuk mindazoknak, akik szeretnék megérteni, hogyan lehet vállalkozásuk sikeres az ESG-korszakban, és versenyelőnyt kovácsolnának a jogszabályi változásokból. Különösen hasznos felső- és operatív vezetők, ESG-feladatokat ellátó szakemberek, pénzügyi és gazdálkodási területen dolgozó kollégák, valamint a marketing, befektetői kommunikációs és HR-csapatok tagjai számára, akik szeretnék megérteni az ESG üzleti hatásait, bevezetésének szempontjait és a kapcsolódó jelentési, kommunikációs, illetve megfelelési követelményeket.',
          location: 'Budapest',
          trainingperiod: 'fél nap',
          traininghours: '4 óra',
          trainingmethod: 'helyszíni',
          trainingpurpose:
            'A képzés célja, hogy a résztvevők gyakorlati ismereteket szerezzenek a magyar ESG-törvény előírásairól, az ESG-beszámolási kötelezettségek teljesítésének követelményeiről és a felkészülés lépéseiről. A program támogatást nyújt az ESG-adatgyűjtési és jelentési folyamatok kialakításában, az ellátási láncok átvilágításában, valamint a jogszabályi megfeleléshez szükséges belső felelősségi körök és működési keretek hatékony kialakításában.',
          urlTraning:
            'https://www.pwc.com/hu/hu/academy/esg/hiteles_vallalati_eszkozrendszer_a_fenntarthatosagi_atalakulashoz.html',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'PwC Könyvvizsgáló Kft. (PwC’s Academy)',
          trainingname: 'ESG szakértő képzés - 4. modul: Fenntarthatósági jelentéstétel',
          targetgroup:
            'Ajánljuk mindazoknak, akik szeretnék megérteni, hogyan lehet vállalkozásuk sikeres az ESG-korszakban, és versenyelőnyt kovácsolnának a jogszabályi változásokból. Különösen hasznos felső- és operatív vezetők, ESG-feladatokat ellátó szakemberek, pénzügyi és gazdálkodási területen dolgozó kollégák, valamint a marketing, befektetői kommunikációs és HR-csapatok tagjai számára, akik szeretnék megérteni az ESG üzleti hatásait, bevezetésének szempontjait és a kapcsolódó jelentési, kommunikációs, illetve megfelelési követelményeket.',
          location: 'Budapest',
          trainingperiod: 'fél nap',
          traininghours: '4 óra',
          trainingmethod: 'helyszíni',
          trainingpurpose:
            'A képzés célja, hogy a résztvevők átfogó és gyakorlati ismereteket szerezzenek a fenntarthatósági jelentéstétel követelményeiről, folyamatáról és üzleti jelentőségéről. A program felkészíti őket a CSRD és az EU Taxonómia előírásainak alkalmazására, a kettős lényegesség elemzés elvégzésére, valamint arra, hogy a fenntarthatósági adatokat ne csak jelentéstételi célokra, hanem a vállalati döntéshozatal és stratégiai tervezés támogatására is hatékonyan használják.',
          urlTraning:
            'https://www.pwc.com/hu/hu/academy/esg/hiteles_vallalati_eszkozrendszer_a_fenntarthatosagi_atalakulashoz.html',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        /* {
          name: 'SALDO Pénzügyi Tanácsadó és Informatikai Zrt.',
          trainingname: 'ESG alapismeretek',
          targetgroup:
            'A pénzügyi, gazdasági területen dolgozó számvitellel, adózással foglakozó szakembereknek ajánlott. Olyan gazdasági szakembereknek, akik az adott vállalkozás, cég esetében az ESG  beszámoló összeállításban közre kell működniük. ',
          location: 'Budapest',
          trainingperiod: '2025.06.02 - 2025.07.21.',
          traininghours: '14 óra',
          trainingmethod: 'online',
          trainingpurpose:
            'A kurzus alapvetően a Magyarországon érvényben lévő ESG jogszabályok (EU CSRD ESRS, Számviteli törvény vonatkozó részei, CSDDD, ESG törvény) és azokból adódó kötelezettségek megismerésére fókuszál. Érintőlegesen – a jelentős elterjedtség okán – kitérünk a GRI Standard jellemzőire is.',
          urlTraning: 'https://saldokurzus.hu/oktatas/esg-alapismeretek-kepzes/1630',
          logo: require('../assets/img/logoESGKepzes.png')
        }, */
        {
          name: 'Sämling Solution Consulting Kft.',
          trainingname: 'Fenntarthatósági Alapismeretek képzés',
          targetgroup:
            'Fenntarthatósági Alapismeretek képzésünk bárkinek hasznos, aki fenntarthatósági szempontokat szeretne beilleszteni egy szervezet kultúrájába.',
          location: 'Budapest',
          trainingperiod: '2 nap',
          traininghours: '16 óra',
          trainingmethod: 'helyszíni',
          trainingpurpose:
            'Intenzív képzésünk átfogó és gyakorlatias képet ad a fenntarthatósághoz köthető fogalmakról, fejleményekről, szabályozási környezetről, lehetőségekről, kihívásokról és mindezek hatásáról a gazdasági élet szereplői számára. Célunk nem csupán a „jól informáltság” elérése, hanem konkrét változások generálása a résztvevőket delegáló szervezetek környezeti hatásában.',
          urlTraning: 'https://www.samlingsolution.hu/nyilt-kepzes/fenntarthatosagi-alapismeretek-kepzes/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Schneider Electric Hungária Villamossági Zrt.',
          trainingname: 'Fenntarthatósági Iskola',
          targetgroup:
            'A képzés elsősorban olyan vállalati döntéshozóknak, tanácsadóknak és partnereknek szól, akik szeretnék elmélyíteni ismereteiket a dekarbonizáció, a digitalizáció és az energiahatékonyság területén.',
          location: 'online',
          trainingperiod: '1-2 nap',
          traininghours: '8,5 óra',
          trainingmethod: 'online',
          trainingpurpose:
            'Fenntarthatósági szakértővé válás, Dekarbonizációs tervek kidolgozása, Energiahatékonyság növelése',
          urlTraning: 'https://www.se.com/hu/hu/work/solutions/sustainability/school-training-and-online-courses/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'STAMP Solutions Kft.',
          trainingname:
            'Az ESG alapjaitól a teljesítmény fejlesztéséig: ESG fejlesztési program a kulcsterületekre fókuszálva',
          targetgroup:
            'A programot olyan vállalatok szakértőinek, vezetőinek és csoportjaiknak ajánljuk, akik szervezetükben különböző ESG ügyekért felelősek, ideértve többek között (E) a műszaki és energetikai, gyártási és logisztikai tevékenységeket; (S) a HR, PR és kommunikációs részlegeket; (G) illetve a stratégiai, innovációs, minőségirányítási és folyamatfejlesztési területeket.',
          location: 'Budapest',
          trainingperiod: '3 nap',
          traininghours: '24 óra',
          trainingmethod: 'helyszíni',
          trainingpurpose:
            'A három workshopból álló program célja, hogy - az ESG alapjainak ismertetése után, illetve túllépve a jogszabályi megfelelésen - már a jövőbeli ESG minősítéseket figyelembe véve segítse elő az ESG teljesítmény fejlesztését olyan kulcsterületeken, mint (E) a karbonlábnyom számítása és a dekarbonizáció; (S) a külső és belső érintetti kapcsolatok fejlesztése; (G) illetve a stratégiai adaptáció, az ESG monitoring és a fenntarthatósági innovációmenedzsment.',
          urlTraning: 'https://stamp.solutions/esg-workshop/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Sustainable Business Academy Kft',
          trainingname: 'Fenntarthatósági Menedzser Képzés',
          targetgroup: 'Vállalati fenntarthatósági, ESG, kommunikációs, HR, EHS, környezetiszakemberek',
          location: 'Budapest és online',
          trainingperiod: '9 hónap',
          traininghours: '210 óra',
          trainingmethod: 'hibrid',
          trainingpurpose: 'Általános fenntarthatósági ismeretek elsajátítása gyakorlati tudás',
          urlTraning: 'https://helloimpact.hu/sustainable-business-academy/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Sustainable Business Academy Kft',
          trainingname: 'VSME - önkéntes jelentéskészítés kkv-k számára',
          targetgroup: 'Cégvezetőknek, fenntarthatósági szakembereknek ajánljuk.',
          location: 'Online',
          trainingperiod: '5 hét',
          traininghours: '30 óra',
          trainingmethod: 'online',
          trainingpurpose:
            'A VSME képzés célja, hogy a vállalkozások vezetőinek, fenntarthatósági szakembereinek és minden érdeklődőnek lehetőséget biztosítson az önkéntes jelentéstételi szabvány hátterének, működésének és gyakorlati alkalmazási lehetőségeinek megismerésére, a vállalati átláthatóság és versenyképesség erősítése érdekében. A képzés kitér azokra a nagyvállalatokra is, amelyeket az Omnibus-rendelet 2 éves halasztása érint.',
          urlTraning:
            'https://sba.hellononprofit.hu/tematikus-kepzesek/vsme-onkentes-fenntarthatosagi-jelentes-kkv-knak/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Sustainable Business Academy Kft',
          trainingname: 'Kommunikáció a vállalati fenntarthatóságban',
          targetgroup:
            'Ajánjuk a fenntarthatósági, kommunikáció, PR, marketing, employer branding területen dolgozó szakembereknek',
          location: 'Budapest és online',
          trainingperiod: '10 hét',
          traininghours: '60 óra',
          trainingmethod: 'hibrid',
          trainingpurpose:
            'A tananyag olyan készségekkel ruházza fel a belső és/vagy külső kommunikációs feladatokat ellátó szakembereket, amelyekkel hatékonyan közvetíthetik a fenntarthatósági kezdeményezéseket, összehangolhatják a belső és külső üzeneteket, és bevonhatják az érdekelt feleket a vállalat fenntartható működésének támogatásába.',
          urlTraning: 'https://sba.hellononprofit.hu/tematikus-kepzesek/kommunikacio-es-fenntarthatosag/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Sustainable Business Academy Kft',
          trainingname: 'Természeti kockázat és biodiverzitás-jelentéstétel',
          targetgroup:
            'Ajánlott célcsoport: Vállalati fenntarthatósági/ESG szakemberek, vezetők, kockázatkezelési és pénzügyi szakemberek, valamint kis- és középvállalatok munkatársai, akik bankoktól, befektetőktől vagy nagy vevőiktől kapnak természeti/biodiverzitás-adatkéréseket.',
          location: 'Budapest (valamint online)',
          trainingperiod: '6 hét',
          traininghours: '40 óra',
          trainingmethod: 'hibrid',
          trainingpurpose:
            'Annak elsajátítása, hogyan mérje fel, közölje és kezelje egy vállalat a természeti kockázatait és biodiverzitásra gyakorolt hatásait: TNFD LEAP-módszertan, GRI 101, ISO 17298, ISSB, ESRS E4, EUDR és az EU-szabályozás egy rendszerben. A résztvevők a saját szervezetükre készített kockázat- és hatáselemzéssel, valamint természeti stratégiavázlattal zárnak.',
          urlTraning: 'https://helloimpact.hu/kepzesek/termeszeti-kockazat-es-biodiverzitas-jelentestetel/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Sustainable Business Academy Kft',
          trainingname: 'Körforgásos gazdasági átállás a gyakorlatban',
          targetgroup:
            'Ajánlott célcsoport: Fenntarthatósági, beszerzési, termelési és operations területen dolgozó vállalati szakemberek, akiknél a hulladék-, csomagolás- vagy anyaggazdálkodás, illetve az ESRS E5 szerinti jelentéstétel összefut, vagy akiktől vevőik körforgásos adatokat kérnek.',
          location: 'Budapest (valamint online)',
          trainingperiod: '10 hét',
          traininghours: '80 óra',
          trainingmethod: 'hibrid',
          trainingpurpose:
            'Kétszintű (alapozó és mélyülő) képzés arról, hogyan mérje fel egy vállalat az anyag- és hulladékáramait, hogyan riportáljon az ESRS E5 szerint, hogyan értelmezze az LCA-eredményeket, és hogyan építsen körforgásos üzleti modellt. Szabályozási térkép (Green Deal, CEAP, EPR, PPWR, EmpCO, Right to Repair, Ecodesign, ESRS E5); a résztvevők átállási roadmapet állítanak össze a saját szervezetükre.',
          urlTraning: 'https://helloimpact.hu/kepzesek/korforgasos-atallas/',
          logo: require('../assets/img/logoESGKepzes.png')
        },
        {
          name: 'Zöld Consulting Kft (Forró Attila EV)',
          trainingname:
            'ESG alapjai, ESG beszállítói kérdőív-beszállítói együtműködés, Zöld pénzügyek, Felelős foglalkoztatás',
          targetgroup: 'Célcsoport: MKV és KKV-k',
          location: 'Magyarország teljes területe, de Közép- és Észak-Magyarország a fő preferált',
          trainingperiod: 'Általában 2 alkalom',
          traininghours: '6-24 óra',
          trainingmethod: 'Ügyféligény alapján',
          trainingpurpose: 'Alapvető tudás megteremtése, illetve a beszállítói szerep erősítése',
          urlTraning: 'https://zoldconsulting.hu/esg-treningek/',
          logo: require('../assets/img/logoESGKepzes.png')
        }
      ]
    }
  },
  methods: {
    handleOpenLinkInNewTab(link) {
      window.open(link, '_blank')
    }
  }
}
</script>

<style scoped>
.boxSecond {
  font-size: larger;
  border-radius: 12px;
  border: black;
}

.blockBox {
  font-size: medium;
}

.margin-box {
  margin: 3%;
}

.button {
  background: rgb(204, 233, 216) !important;
  font-weight: 600;
  color: black !important;
  height: 48px;
  line-height: 32px;
  border-radius: 8px;
  border: none;
}

.buttonScrolling {
  width: 100%;
  background-color: rgb(0, 144, 60);
  color: white;
  font-weight: bold;
  border: 0;
  outline: none;
  font-size: medium;
  padding: 5px;
  align-items: center;
}

.name {
  color: rgb(0, 144, 60);
}

.BoxTitleMobil {
  font-weight: bold;
  text-align: left;
  display: flex;
  justify-content: flex-start;
}

.expert-image-wrapper {
  height: 100%;
}

.expert-title {
  color: #636e72;
  height: 100%;
  display: flex;
  font-size: large;
  align-items: center;
  text-align: center;
  justify-content: center;
}

.expert-title_date {
  color: #636e72;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.expert-title-mobil {
  height: 100%;
  display: flex;
  font-size: large;
  align-items: left;
  justify-content: left;
}
.wrapper {
  background-color: rgb(204, 233, 216);
  border-radius: 10px 10px 0 0;
  padding: 35px;
  margin: auto;
}
.wrapper-small {
  background-color: rgb(0, 144, 60);
  padding: 20px;
  border-radius: 0 0 10px 10px;
}
.button-href {
  background-color: rgb(204, 233, 216) !important;
  color: black !important;
  padding: 10px 30px !important;
  border-radius: 9px !important;
  text-decoration: none !important;
  font-size: 13.5px;
  font-weight: bold !important;
  text-align: center !important;
  margin-left: 40px;
  white-space: nowrap;
}
.p-style {
  font-size: 16px;
  line-height: 1.5;
  text-align: justify;
}
.p-style-2 {
  color: white;
  display: flex;
  align-items: center;
  gap: 20px;
  margin-right: 60px;
  text-align: left;
  margin-left: 15px;
}
.p-style-3 {
  font-size: 16px;
  line-height: 1.5;
  text-align: justify;
  font-style: italic;
}
.logoESGPiacitrening-style {
  max-width: 100%;
  height: auto;
  margin-bottom: 20px;
}
.p-align {
  flex: 1;
  min-width: 300px;
  padding-right: 20px;
}

.headerBox {
  justify-content: center;
}

.boxFirst {
  border-radius: 12px;
  border: black;
}

.offer-width {
  max-width: 800px;
}

.offerbox-holder {
  padding: 20px;
  padding-top: 30px;
  border: 1px solid var(--color-gray-02);
  box-sizing: border-box;
  box-shadow: 0px 2px 12px rgba(45, 52, 54, 0.05);
  min-height: 80px;
}

.offer-name {
  color: var(--color-green);
  font-weight: bold;
}

.offerbox-holder .btn {
  width: 200px;
  height: 48px;
  padding: 11px;
}

.offer-name:focus {
  outline: none;
}

.offerbox-holder .btn {
  width: 200px;
  height: 48px;
  padding: 11px;
}

.collapsed > div > div > .when-opened,
:not(.collapsed) > div > div > .when-closed {
  display: none;
}

.when-opened svg,
.when-closed svg {
  fill: var(--color-green);
  cursor: pointer;
  margin-top: -5px;
  transition: opacity 1s ease-out;
}

.pre-link {
  width: fit-content;
}

.heart-container {
  cursor: pointer;
  position: absolute;
  right: 0px;
  top: 5px;
}

.competition-container {
  position: relative;
}

.offer-button-container {
  background: #ffffff;
  padding: 8px 16px 8px 16px;
  border: 1px solid #dfe6e9;
  box-sizing: border-box;
  border-radius: 4px;
  transition: background 0.1s ease-in-out;
  font-size: 16px;
}

.offer-button-container:hover {
  background: #f2f8fa;
  cursor: pointer;
}

.sub-type-svg-container {
  margin-right: 17px;
}

.activeOfferButton {
  background: #f2f8fa;
}

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}

/* Elem elrejtése mobilon */
@media (max-width: 768px) {
  .desktop-only {
    display: none;
  }
  .margin-box {
    margin: 1.5% !important;
  }
}

@media (max-width: 768px) {
  .button-href {
    display: block;
    margin-top: 10px;
    margin-left: 0;
    text-align: left;
    width: auto;
    font-size: 2.5vw;
  }

  .button-wrapper {
    display: block;
    margin-top: 10px;
    margin-left: -30px;
    text-align: left;
    width: auto;
  }

  .p-style-2 {
    text-align: left;
    margin-bottom: 30px;
    width: 100%;
    display: block;
  }

  .wrapper-small {
    width: 100%;
  }
}

/* Elem elrejtése asztali böngészőben */
@media (min-width: 769px) {
  .mobile-only {
    display: none;
  }
}

.when-opened svg,
.when-closed svg {
  fill: white;
  cursor: pointer;
  margin-top: -1px;
  transition: opacity 1s ease-out;
}
</style>
